import { createActionGroup, props } from '@ngrx/store';
import {
    CreateInquiryDto,
    CreateInitialInquiryVariantDto,
    DocumentDto,
    InquiryDto,
    InquiryOrganizationAccessGrantDto,
    InquiryVariantOverviewDto,
    InquiryVariantPreviewDto,
    UpdateInquiryDto
} from '@travel-planner/library-travel-planner-api';
import { ApiError } from '../../../../core/models/api-error';
import { NavigationDescription } from '../../../../core/models/navigation-description';
import { AutosaveRequestMetadata } from '../../../../core/autosave';

export const InquiriesActions = createActionGroup({
    source: 'Inquiries',
    events: {
        'Load Inquiry': props<{ id: number }>(),
        'Load Inquiry Success': props<{ inquiry: InquiryDto }>(),
        'Load Inquiry Failure': props<{ id: number; error: ApiError }>(),

        'Add Inquiry': props<{ createInquiryDto: CreateInquiryDto }>(),
        'Add Inquiry Success': props<{ inquiry: InquiryDto }>(),
        'Add Inquiry Failure': props<{ error: ApiError }>(),

        'Add Initial Inquiry Variant': props<{ createInitialInquiryVariantDto: CreateInitialInquiryVariantDto }>(),
        'Add Initial Inquiry Variant Success': props<{ inquiryVariant: InquiryVariantOverviewDto; navigateOnSuccess?: NavigationDescription; }>(),
        'Add Initial Inquiry Variant Failure': props<{ error: ApiError }>(),

        'Update Inquiry': props<{ id: number; updateInquiryDto: UpdateInquiryDto; autosave?: AutosaveRequestMetadata }>(),
        'Update Inquiry Success': props<{ inquiry: InquiryDto; autosave?: AutosaveRequestMetadata }>(),
        'Update Inquiry Failure': props<{ id: number; error: ApiError; autosave?: AutosaveRequestMetadata }>(),

        'Delete Inquiry': props<{ id: number }>(),
        'Delete Inquiry Success': props<{ id: number; navigateOnSuccess?: NavigationDescription; }>(),
        'Delete Inquiry Failure': props<{ id: number; error: ApiError }>(),

        'Load Inquiry Documents': props<{ id: number }>(),
        'Load Inquiry Documents Success': props<{ id: number; documents: DocumentDto[] }>(),
        'Load Inquiry Documents Failure': props<{ id: number; error: ApiError }>(),

        'Load Inquiry Variants': props<{ id: number }>(),
        'Load Inquiry Variants Success': props<{ id: number; variants: InquiryVariantPreviewDto[] }>(),
        'Load Inquiry Variants Failure': props<{ id: number; error: ApiError }>(),

        'Load Organization Access Grants': props<{ inquiryId: number }>(),
        'Load Organization Access Grants Success': props<{ inquiryId: number; grants: InquiryOrganizationAccessGrantDto[] }>(),
        'Load Organization Access Grants Failure': props<{ inquiryId: number; error: ApiError }>(),

        'Grant Organization Access': props<{ inquiryId: number; organizationId: number }>(),
        'Grant Organization Access Success': props<{ inquiryId: number; grant: InquiryOrganizationAccessGrantDto }>(),
        'Grant Organization Access Failure': props<{ inquiryId: number; organizationId: number; error: ApiError }>(),

        'Revoke Organization Access': props<{ inquiryId: number; organizationId: number }>(),
        'Revoke Organization Access Success': props<{ inquiryId: number; organizationId: number }>(),
        'Revoke Organization Access Failure': props<{ inquiryId: number; organizationId: number; error: ApiError }>(),
    }
});
